"use strict";

var Manifesto = function () {

  var set_load_place = function() {
    $('#manifesto_load_place').val($('#manifesto_dispatch_country_id').val());
  }

  var set_unload_place = function() {
    $('#manifesto_unload_place').val($('#manifesto_destination_country_id').val());
  }

  var set_trailer_infos = function() {
    if ($('#manifesto_trailer_id').data('select2')) {
      $('#manifesto_trailer_coun').val($('#manifesto_trailer_id').select2('data')[0]['country_id']).trigger('change');
      $('#manifesto_trailer_code').val($('#manifesto_trailer_id').select2('data')[0]['text']);
      $('#manifesto_vehicle_coun').val($('#manifesto_trailer_id').select2('data')[0]['country_id']).trigger('change');
    }
  }

  var set_vehicle_infos = function() {
    if ($('#manifesto_vehicle_id').data('select2')) {
      $('#manifesto_vehicle_coun').val($('#manifesto_vehicle_id').select2('data')[0]['country_id']).trigger('change');
      $('#manifesto_vehicle_code').val($('#manifesto_vehicle_id').select2('data')[0]['text']);
      $('#manifesto_trailer_coun').val($('#manifesto_vehicle_id').select2('data')[0]['country_id']).trigger('change');
    }
  }

  var set_route_infos = function(route_id) {
    if (route_id != '') {
      $.ajax({
        type: "GET",
        url: "/routes/" + route_id,
        dataType: "JSON",
        success: function(data) {
          if (data != null) {
            if (data['transit_customs_count'] > 0) {
              change_transit_customs(data['transit_customs_count'], data['transit_customs']);
            }
            if (data['transit_countries_count'] > 0) {
              change_transit_countries(data['transit_countries_count'], data['transit_countries']);
            }
            if (data['transit_customs'] != null){
              change_trans_method_on_route_change(data['trans_method']);
            }
            if (data['transit_countries'] != null){
               change_border_custom_id_on_route_change(data['border_custom']);
            }
            if (data['train'] == true) {
              $('#manifesto_trans_method').val('rail').trigger('change');
              $('#route_train_roro_notification').html('TRAIN');
            } else if (data['roro'] == true) {
              $('#manifesto_trans_method').val('roro').trigger('change');
              $('#route_train_roro_notification').html('RORO');
            } else {
              $('#route_train_roro_notification').html('');
            }
          }
        }
      });
    }
  }

  var set_border_place = function() {
    if ($('#manifesto_departure_custom_id').data('select2')) {
      var departure_country = $('#manifesto_departure_custom_id').select2('data')[0]['country_id'];
      if (departure_country === undefined) {
        departure_country = $('#manifesto_load_coun').val();
      }
      if (departure_country == 'TR') {
        $('#border_custom_id_div').show();
        $('#stamp_duty_div').show();
      } else {
        $('#border_custom_id_div').hide();
        $('#stamp_duty_div').hide();
      }
    }
  }

  var set_goods_location_for_poland = function() {
    if ($('#manifesto_departure_custom_id').data('select2')) {
      var departure_country = $('#manifesto_departure_custom_id').select2('data')[0]['country_id'];
      if (departure_country === undefined) {
        departure_country = $('#manifesto_load_coun').val();
      }
      if (departure_country == "PL") {
        $('#goods_location_div').show();
      } else {
        $('#goods_location_div').hide();
      }
    }
  }

  var change_transit_customs = function(transit_customs_count, transit_customs) {
    var custom_input_counts = $( "select[name*='manifesto[transit_customs_attributes]']" ).length;
    if (transit_customs_count > custom_input_counts) {
      var new_customs_count = transit_customs_count - custom_input_counts;
      for (var i = 0; i < new_customs_count; i++) {
        $( "a[data-behaviour='add_transit_customs']" ).click();
      }
    }
    $( "select[name*='manifesto[transit_customs_attributes]']" ).val("").trigger('change');
    for (var i = 0; i < transit_customs_count; i++) {
      var newOption = new Option((transit_customs[i]['code'] +'-'+ transit_customs[i]['name']), transit_customs[i]['id'], false, true);
      $( "select[name*='manifesto[transit_customs_attributes]']:eq("+ i +")" ).append(newOption).trigger('change');
    }
  }

  var change_transit_countries = function(transit_countries_count, transit_countries) {
      var fields = document.querySelectorAll('.country-document-line');
      fields.forEach(function(field) {
        field.remove();
      });
      for (var i = 0; i < transit_countries_count; i++) {
        $("a[data-behaviour='add_transit_countries']").click();
        var matchingElement = $('[id^="manifesto_transit_countries_attributes_"][id$="_country_id"]:last');
        matchingElement.val(transit_countries[i]).trigger('change');
      }
  };

  var change_trans_method_on_route_change = function(trans_method) {
    if (trans_method === 'sea') {
      $('#manifesto_trans_method').val('roro').trigger('change');
    } else {
      $('#manifesto_trans_method').val(trans_method).trigger('change');
    }
  };

  var change_border_custom_id_on_route_change = function(border_custom) {
    if (border_custom['id'] !== null) {
      var new_value = new Option((border_custom['code'] + '-' + border_custom['name']), border_custom['id'], false, true);
      $('#manifesto_border_custom_id').append(new_value).trigger('change');
    }
  }
  var set_roro_operator = function() {
    if ($('#manifesto_trans_method').val() == "roro" || $('#manifesto_trans_method').val() == "roro_unaccompanied" || $('#manifesto_trans_method').val() == "roro_accompanied" || $('#manifesto_trans_method').val() == "maritime" || $('#manifesto_trans_method').val() == "inland_water_transport") {
      $(".manifesto_ferry_details").show();
    }else{
      $(".manifesto_ferry_details").hide();
      $('#manifesto_roro_operator_code').val("");
    }
  };

  var set_ro_different_customs_box = function() {
    $("#good_exp_customs_partial").prop('checked', false);
    var dep_custom_country_id = $('#good_invoice_country_id').val();
    var dep_custom_code = $('#manifesto_departure_custom_code').val();
    var exp_customs_no  = $('#good_exp_customs_no').val();
    if ((exp_customs_no != '') && (dep_custom_country_id == 'RO')) {
      exp_customs_no_custom_code = exp_customs_no.substr(2, 8);
      if (exp_customs_no_custom_code != dep_custom_code) {
        $("#good_exp_customs_partial").prop('checked', true);
      }
    }
  }

  var set_aeo_fields = function() {
    if ($('#manifesto_is_aeo').is(':checked')) {
      $('#goods_location_div').show();
      $('#transit_date_div').show();
      $('#aeo_location_div').show();
    } else {
      $('#transit_date_div').hide();
      $('#aeo_location_div').hide();
      set_goods_location_for_poland();
    }
  }

  var set_auth_code = function() {
    var location_code = $('#manifesto_aeo_location').val();
    if (location_code !== null && location_code !== '') {
      var loc_auth_code = $('#manifesto_aeo_location>option[value="' + location_code + '"]').attr('data-auth-code');
      if (loc_auth_code !== null && loc_auth_code !== '') {
        $('#manifesto_load_place').val(loc_auth_code);
      }
    }
  }


  return {
    init: function () {

      $(document).on("change", "#manifesto_dispatch_country_id", function() {
        set_load_place();
      });

      $(document).on("change", "#manifesto_destination_country_id", function() {
        set_unload_place();
      });

      $(document).on("change", "#good_exp_customs_no", function(event) {
        set_ro_different_customs_box();
      });

      $(document).on("change", "#manifesto_trailer_id", function(event) {
        set_trailer_infos();
      });

      $(document).on("change", "#manifesto_vehicle_id", function(event) {
        set_vehicle_infos();
      });

      $(document).on("change", "#manifesto_is_aeo", function(event) {
        set_aeo_fields();
      });
      set_aeo_fields();

      $(document).on("change", "#manifesto_aeo_location", function(event) {
        set_auth_code();
      });

      $(document).on("change", "#manifesto_departure_custom_id", function(event) {
        set_goods_location_for_poland();
        set_border_place();
      });
      set_border_place();
      set_goods_location_for_poland();
      $(document).on("change", "#manifesto_trans_method", function(event) {
        set_roro_operator();
      });
      set_roro_operator();
    },
    set_load_place: function () {
      set_load_place();
    },
    set_unload_place: function () {
      set_unload_place();
    },
    set_trailer_infos: function() {
      set_trailer_infos();
    },
    set_vehicle_infos: function() {
      set_vehicle_infos();
    },
    set_route_infos: function(route_id) {
      set_route_infos(route_id);
    },
    set_ro_different_customs_box: function () {
      set_ro_different_customs_box();
    }
  };
}();

if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
  module.exports = Manifesto;
}